'use client';
/* eslint-disable new-cap */

import { accordion } from './accordion';
import { alert } from './alert';
import { autocomplete } from './autocomplete';
import { avatar } from './avatar';
import { backdrop } from './backdrop';
import { badge } from './badge';
import { button } from './button';
import { buttonGroup } from './buttonGroup';
import { card } from './card';
import { checkbox } from './checkbox';
import { chip } from './chip';
import { container } from './container';
import { controlLabel } from './controlLabel';
import { cssBaseline } from './cssBaseline';
import { dataGrid } from './dataGrid';
import { dialog } from './dialog';
import { drawer } from './drawer';
import { fab } from './fab';
import { input } from './input';
import { link } from './link';
import { lists } from './lists';
import { loadingButton } from './loadingButton';
import { menu } from './menu';
import { pagination } from './pagination';
import { paper } from './paper';
import { popover } from './popover';
import { progress } from './progress';
import { radio } from './radio';
import { rating } from './rating';
import { select } from './select';
import { skeleton } from './skeleton';
import { slider } from './slider';
import { stepper } from './stepper';
import { svgIcon } from './svgIcon';
import { muiSwitch } from './switch';
import { table } from './table';
import { tabs } from './tabs';
import { toggleButton } from './toggleButton';
import { tooltip } from './tooltip';
import { typography } from './typography';

import type { Theme } from '@mui/material/styles';
import type { Components } from '@mui/material/styles/components';
import type { Mixins } from '@mui/material/styles/createMixins';
import type { Palette } from '@mui/material/styles/createPalette';
import type { Transitions } from '@mui/material/styles/createTransitions';
import type { Typography } from '@mui/material/styles/createTypography';
import type { Shadows } from '@mui/material/styles/shadows';
import type { ZIndex } from '@mui/material/styles/zIndex';
import type { Theme as SystemTheme } from '@mui/system/createTheme/createTheme';

export interface BaseTheme extends SystemTheme {
  mixins: Mixins;
  palette: Palette;
  shadows: Shadows;
  transitions: Transitions;
  typography: Typography;
  zIndex: ZIndex;
  unstable_strictMode?: boolean;
}
export const components: Components<Theme> = {
  ...link,
  ...badge,
  ...paper,
  ...select,
  ...svgIcon,
  ...container,
  ...cssBaseline,
  ...loadingButton,
  ...fab,
  ...tabs,
  ...chip,
  ...card,
  ...menu,
  ...input,
  ...radio,
  ...lists,
  ...table,
  ...alert,
  ...muiSwitch,
  ...button,
  ...rating,
  ...dialog,
  ...avatar,
  ...slider,
  ...drawer,
  ...stepper,
  ...tooltip,
  ...popover,
  ...checkbox,
  ...dataGrid,
  ...skeleton,
  ...backdrop,
  ...progress,
  ...accordion,
  ...typography,
  ...pagination,
  ...buttonGroup,
  ...autocomplete,
  ...controlLabel,
  ...toggleButton,
};
